module.exports = __webpack_public_path__ + "fonts/Inter-Medium.7a8cc72.woff";